import React, { useState } from 'react';
import { connect } from 'react-redux';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import BasePage from 'apps/auth/components/utils/BasePage';
import { resolveArguments } from 'apps/auth/helpers/utils';
import AntifraudGTAmlLevelDocsPage from 'apps/auth/pages/antifraud/AntifraudGTAmlLevelDocsPage';

const AntifraudGTAmlLevelInfoPage = (props) => {
    const [showDocs, setShowDocs] = useState(false);

    const notNowButtonClick = (e) => {
        e?.preventDefault();
        props.toggleSpinner(true);
        window.location.href = props.notNowLink;
    };

    if (showDocs) {
        return <AntifraudGTAmlLevelDocsPage />;
    }

    return (
        <BaseLayout showChat={false}>
            <InfoPage
                iconName="speedometer-low-80"
                iconColor="primary"
                headerText={
                    <>
                        <span className="color-GT">{resolveArguments(props.profilePurpleBlock, props.aml_level_name)}</span>
                        <br /> &nbsp;
                        {props.increase_block}
                    </>
                }
                secondaryText={<DangerouslyHtml dangerouslyHtml={props.increase_sub_block} />}
                topButtonCaption={props.notificationButton}
                topButtonType="link"
                topButtonLink={props.notNowLink}
                topButtonOnClick={notNowButtonClick}
                primaryButtonCaption={props.nextButton}
                primaryButtonOnClick={() => setShowDocs(true)}
            />
        </BaseLayout>
    );
};
const mapStateToProps = (state) => {
    return {
        aml_level_name: state.messages.pageMessages.aml_level_name,
        increase_block: state.messages.pageMessages.increase_block,
        increase_sub_block: state.messages.pageMessages.increase_sub_block,
        nextButton: state.messages.pageMessages.nextButton,
        notificationButton: state.messages.pageMessages.notificationButton,
        profilePurpleBlock: state.messages.pageMessages.profilePurpleBlock,
        current_limit: state.extra.current_limit,
        notNowLink: state.extra.notNowLink,
    };
};
export default connect(mapStateToProps)(BasePage(AntifraudGTAmlLevelInfoPage));
